import api from "../api";

export const notificationsService = {
  async list(accountId = null) {
    const response = await api.get("/api/v1/notifications/", {
      params: accountId ? { account_id: accountId } : {},
    });
    return response.data;
  },

  async unreadCount(accountId = null) {
    const response = await api.get("/api/v1/notifications/unread-count/", {
      params: accountId ? { account_id: accountId } : {},
    });
    return response.data;
  },

  async markRead(notificationId) {
    const response = await api.patch(
      `/api/v1/notifications/${notificationId}/read/`,
      {},
    );
    return response.data;
  },

  async markAllRead(accountId = null) {
    const response = await api.patch(
      "/api/v1/notifications/read-all/",
      null,
      {
        params: accountId ? { account_id: accountId } : {},
      },
    );
    return response.data;
  },
};
